<template>
  <div class="mx-auto max-w-[320px]">
    <form class="space-y-4 text-center" @submit.prevent="handleUpdatePassword">
      <div>
        <PrimeFloatLabel variant="on">
          <PrimePassword
            v-model="currentPassword"
            input-id="currentPassword"
            class="w-full"
            :feedback="false"
            autocomplete="current-password"
            toggle-mask
            required
          />
          <label for="currentPassword">{{ $t('components.settings.security.currentPassword') }}</label>
        </PrimeFloatLabel>

        <div class="text-end">
          <PrimeButton
            as="router-link"
            :to="localePath('forgot-password')"
            link
            :label="$t('components.settings.security.forgotPassword')"
            class="text-end text-sm"
          />
        </div>
      </div>
      <CreatePassword @password-created="handlePasswordUpdated" />

      <PrimeButton
        type="submit"
        :loading="pending"
        :label="pending ? $t('components.settings.security.updatingPassword') : $t('components.settings.security.updatePassword')"
      />
    </form>
  </div>
</template>

<script>
import messages from '~/assets/jsons/messages.json';
import CreatePassword from '~/components/auth/CreatePassword.vue';
import { useLocalePath } from '#i18n';

export default defineNuxtComponent({
  components: {
    CreatePassword
  },
  setup() {
    const localePath = useLocalePath();
    return { localePath };
  },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      pending: false,
    };
  },
  methods: {
    handlePasswordUpdated(password) {
      this.newPassword = password;
    },
    async handleUpdatePassword() {
      this.pending = true;
      if (!this.newPassword) {
        this.$toast.add({
          severity: 'error',
          summary: 'Update Failed',
          detail:
            'Your password must meet all requirements and match the confirmation.',
          life: 4000,
        });
        this.pending = false;

        return;
      }
      if (this.newPassword === this.currentPassword) {
        this.$toast.add({
          severity: 'error',
          summary: 'Update Failed',
          detail:
            'Your new password can not be the same with your current password.',
          life: 4000,
        });
        this.pending = false;

        return;
      }
      const payload = {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      };
      const { error } = await useApi('/api/auth/update-password', {
        method: 'PATCH',
        body: payload,
      });
      if (error) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('components.settings.security.updateFailed'),
          detail: this.$t('errors.' + error),
          life: 4000,
        });
      } else {
        this.$toast.add({
          severity: 'success',
          summary: this.$t('components.settings.security.updateSuccessfully'),
          detail: this.$t('components.settings.security.passwordUpdatedSuccessfully'),
          life: 4000,
        });
      }

      this.pending = false;
    },
  },
});
</script>

<style  scoped></style>
